import React, { useEffect, useState, useContext, useRef } from "react";
import Tooltip from "@mui/material/Tooltip";
import { useNavigate, Link } from "react-router-dom";
import axios from "axios";
import Card from "react-bootstrap/Card";
import { confirmAlert } from "react-confirm-alert";
import "antd/dist/antd.min.css";
import { Modal } from "react-bootstrap";
import { DataGrid } from "@material-ui/data-grid";
import toast from "react-hot-toast";
import { makeStyles } from "@material-ui/core/styles";
import Badge from "react-bootstrap/Badge";
import { DatePicker, Space } from "antd";
import { Button } from "react-bootstrap";
//Global State import
import { useAtom } from "jotai";
import { gbState } from "../../../components/shared/GlobalState";

//Context import
import AuthContext from "../../../components/shared/Context";
import ExcelDownloader from "./ExcelDownloader";

import Form from "react-bootstrap/Form";
import InputGroup from "react-bootstrap/InputGroup";

const { RangePicker } = DatePicker;
const ListSalesChild = () => {
  let navigate = useNavigate();
  const { loggedInUserDetails } = useContext(AuthContext);
  const [data, setData] = useState([]);
  const [unfilteredData, setUnfilteredData] = useState([]);
  const [openModal, setOpenModal] = useState(false);
  const [currentRecord, setCurrentRecord] = useState({});
  const [selectedIds, setSelectedIds] = useState([]);
  const searchRef = useRef();

  //Error Logging Service
  const [{ errorLogApi, dateFormatter, expiryFormatter }] = useAtom(gbState);

  const [durationResult, setDurationResult] = useState([]);
  //date range selector code
  const [dates, setDates] = useState(null);
  const [dateValue, setDateValue] = useState(null);
  const [dateInterval, setDateInterval] = useState({});
  const disabledDate = (current) => {
    if (!dates) {
      return false;
    }
    const tooLate = dates[0] && current.diff(dates[0], "days") > 365;
    const tooEarly = dates[1] && dates[1].diff(current, "days") > 365;
    return !!tooEarly || !!tooLate;
  };
  const onOpenChange = (open) => {
    if (open) {
      setDates([null, null]);
    } else {
      setDates(null);
    }
  };

  const searchRecordsBetweenDates = (field) => {
    if (dateInterval) {
      //alert("started");
      const data_res = data.filter((d) => {
        var time = new Date(d[field]).getTime();
        return dateInterval.sd <= time && time <= dateInterval.ed;
      });
      setDurationResult(data_res);
      setData(data_res);
    }
  };

  useEffect(() => {
    if (dateValue) {
      setDateInterval({
        sd: new Date(dateValue[0]).getTime(),
        ed: new Date(dateValue[1]).getTime(),
      });
    }
  }, [dateValue]);

  const getDataFromServer = () => {
    const config = {
      headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
    };
    const bodyParameters = {
      key: "value",
    };
    let urlLink = `${process.env.REACT_APP_API_URL}/state/sales/${loggedInUserDetails.state}`;
    if (loggedInUserDetails.role === "FULL_ACCESS") {
      urlLink = `${process.env.REACT_APP_API_URL}/state/purchases/`;
    }
    // if (loggedInUserDetails.role === "ST_ADM_ACCESS") {
    //   urlLink = `${process.env.REACT_APP_API_URL}/suppliers/state/${loggedInUserDetails.state}`;
    // }
    axios
      .get(urlLink, config)
      .then((res) => {
        const oldData = res?.data?.sales;
        //console.log(oldData);
        if (oldData) {
          const updatedData = oldData.map((data) => {
            //   console.log(data.purchase_inventory.product_id.products);
            return {
              ...data,
              id: data?._id,
              product_code: data?.s_register?.product_id?.products?.item_code,
              product_name:
                data?.s_register?.product_id?.products?.product_name,
              product_expiry:
                data?.s_register?.purchase_id?.p_register?.expiry_date,
              sale_date: data?.s_register?.sale_date.split("T")[0],
              sale_code: data?.s_register?.sale_id,
              quantity: data?.s_register?.quantity,
              allotment_recieved_status:
                data?.s_register?.allotment_recieved_status,
              tc_name: data?.s_register?.tc_id?.tcenters?.name_tc,
              state: data?.s_register?.state,
              comments: data?.s_register?.comments,
              reciever_comments: data?.s_register?.reciever_comments,
              allot_status: data?.s_register?.allotment_recieved_status
                ? "Recieved"
                : "Pending",
            };
          });
          //console.log(updatedData);
          setData(updatedData);
          setUnfilteredData(updatedData);
        } else {
          return null;
        }
      })
      .catch((err) => console.log("error", err));
  };

  useEffect(() => {
    getDataFromServer();
  }, []);

  const handleDelete = (id) => {
    confirmAlert({
      title: "",
      message: "Are you sure to delete this Product ?",
      buttons: [
        {
          label: "Yes",
          onClick: () => deleteRecord(id),
        },
        {
          label: "No",
          //onClick: () => alert('Click No')
        },
      ],
    });
  };

  const deleteRecord = (id) => {
    let userToken = localStorage.getItem("token");
    const config = {
      headers: { Authorization: `Bearer ${userToken}` },
    };
    axios
      .delete(
        `${process.env.REACT_APP_API_URL}/state/sales/delete/${id}`,
        config
      )
      .then((response) => {
        getDataFromServer();
      })
      .catch((error) => {
        toast.error(error?.response?.data?.message);
      });
  };

  const useStyles = makeStyles(() => ({
    multiLineCell: {
      display: "flex",
      wordBreak: "keep-all",
      wordWrap: "break-word",
      overflowWrap: "break-word",
      flexDirection: "column",
      justifyContent: "center",
      alignItems: "flex-start",
      lineHeight: "1.2rem",
      height: "100%",
    },
  }));

  const calculateDaysLeft = (date) => {
    // Convert the given date string to a Date object
    const givenDate = new Date(date);

    // Calculate the difference between the current date and the given date in milliseconds
    const timeDiff = givenDate.getTime() - new Date().getTime();

    // Convert milliseconds to days and round down to the nearest integer
    const days = Math.floor(timeDiff / (1000 * 60 * 60 * 24));

    // Update the state with the number of days left
    //setDaysLeft(days);
    return days;
  };

  const MultiLineCellRenderer = (params) => {
    const classes = useStyles();
    const daysLeft = calculateDaysLeft(params.row.product_expiry);

    return (
      <div className={classes.multiLineCell}>
        <span id="content1">
          <b>{params.row.product_name}</b>
        </span>
        <span id="content2">
          <small className="small-font-size">
            {/* Expiry:{" "}
            {daysLeft !== null ? (
              `${expiryFormatter(params.row.product_expiry)} (${daysLeft}) days`
            ) : (
              <p>Loading...</p>
            )} */}
            {params.row.product_code}
          </small>
        </span>
      </div>
    );
  };

  const columns = [
    {
      field: "Action",
      headerName: "Action",
      filterable: false,
      sortable: false,
      disableColumnMenu: true,
      width: 80,
      align: "center",
      renderCell: (params) => {
        return (
          <div className="editiConContainer">
            <Tooltip title="View PO">
              <a onClick={() => viewRecord(params.row)}>
                <i
                  className="mdi mdi-eye-circle-outline"
                  style={{ fontSize: "15px", color: "black" }}
                ></i>
              </a>
            </Tooltip>
            <Tooltip title="Edit PO">
              <div onClick={() => navigate("/updatepo", { state: params.row })}>
                <i
                  className="mdi mdi-square-edit-outline"
                  style={{ fontSize: "15px", color: "grey", cursor: "pointer" }}
                ></i>
              </div>
            </Tooltip>
            <Tooltip title="Delete PO">
              <div onClick={() => handleDelete(params.row._id)}>
                <i
                  className="mdi mdi-trash-can-outline"
                  style={{ fontSize: "15px", color: "red", cursor: "pointer" }}
                ></i>
              </div>
            </Tooltip>
          </div>
        );
      },
    },
    {
      field: "sale_date",
      headerName: "Issue Date",
      disableColumnMenu: true,
      width: 130,
      align: "center",
    },
    {
      field: "product_name",
      headerName: "Product",
      width: 240,
      renderCell: MultiLineCellRenderer,
    },
    {
      field: "sale_code",
      headerName: "Issue ID",
      disableColumnMenu: true,
      width: 130,
      align: "center",
    },
    {
      field: "quantity",
      headerName: "Issue. Qty",
      filterable: false,
      disableColumnMenu: true,
      width: 130,
      align: "center",
    },
    {
      field: "allotment_recieved_status",
      headerName: "Issue Status",
      width: 140,
      filterable: false,
      disableColumnMenu: true,
      renderCell: (params) => {
        if (!params.row.allotment_recieved_status) {
          return <Badge bg="warning">AWAITING RECEIPT</Badge>;
        } else {
          return (
            <Badge bg="success">&nbsp;&nbsp;RECIEVED BY TC&nbsp;&nbsp;</Badge>
          );
        }
      },
      align: "center",
    },
    // {
    //   field: "product_expiry",
    //   headerName: "Expiry",
    //   width: 120,
    //   renderCell: (params) =>
    //     isNaN(params.row.expiry_status) ? (
    //       <Badge bg="danger">Expired</Badge>
    //     ) : (
    //       <Badge bg="success">
    //         ( {calculateDaysLeft(params.row.product_expiry)} ) days left
    //       </Badge>
    //     ),
    // },
    {
      field: "tc_name",
      headerName: "TC Name",
      width: 200,
    },

    {
      field: "state",
      headerName: "State",
      width: 130,
    },
  ];

  const viewRecord = (rec) => {
    setCurrentRecord(rec);
    setOpenModal(true);
  };
  //   console.log(data);

  let unfilterData = data;
  const handleSearch = (e) => {
    console.log("Search Value...", e);

    if (e) {
      setData(
        unfilterData.filter((item) => {
          return (
            item?.tc_name?.toLowerCase().includes(e?.toLowerCase()) ||
            item?.product_name?.toLowerCase().includes(e?.toLowerCase()) ||
            item?.company_name?.toLowerCase().includes(e?.toLowerCase()) ||
            item?.sale_code?.toLowerCase().includes(e?.toLowerCase()) ||
            item?.state?.toLowerCase().includes(e?.toLowerCase())
          );
        })
      );
    } else {
      getDataFromServer();
    }
  };

  const clearSearch = () => {
    searchRef.current.value = null;
    getDataFromServer();
  };

  //Bulk Delete function
  const handleSelectionChange = (selectionModel) => {
    // `selectionModel` will be an array of IDs of selected rows
    setSelectedIds(selectionModel);
  };

  const deleteMultipleRecords = () => {
    let inputCode = "";
    if (!selectedIds?.length) return toast.error("Please select Record(s)");

    confirmAlert({
      title: "",
      message: "Are you sure to delete record(s) ?",
      childrenElement: () => (
        <div>
          {/* Use the key here */}
          <input
            type="text"
            placeholder="Type Code..."
            className="mt-2"
            onChange={(e) => (inputCode = e.target.value)} // Direct assignment
          />
        </div>
      ),
      buttons: [
        {
          label: "Yes",
          onClick: () => deleteRecordInBulk(inputCode),
        },
        {
          label: "No",
          //onClick: () => alert('Click No')
        },
      ],
    });
  };

  const deleteRecordInBulk = (inputCode) => {
    if (!inputCode) return toast.error("Please enter a valid code!");

    let userToken = localStorage.getItem("token");
    const config = {
      method: "post",
      url: `${process.env.REACT_APP_API_URL}/state/sales/delete/bulk`,
      headers: {
        Authorization: `Bearer ${userToken}`,
      },
      data: { ids: selectedIds, secret_code: inputCode },
    };
    if (selectedIds.length > 0) {
      axios(config)
        .then(function (response) {
          getDataFromServer();
          toast.success("Stock Deleted Successfully.");
        })
        .catch(function (error) {
          errorLogApi(error, "PWStockDeleteMany", "/delete/bulk");
          toast.error(JSON.stringify(error.response.data.message));
        });
    }
  };

  return (
    <div>
      <span className="">
        <h3>TC Allocations/Issue Register</h3>
      </span>
      <div className="text-end">
        <ExcelDownloader
          data={data}
          excludedFields={[
            "id",
            "_id",
            "product_stock",
            "__v",
            "allotment_recieved_status",
            "s_register",
          ]}
          filename={`TCAllocation_stock_${new Date()
            .toISOString()
            .replace(/[-:.]/g, "")}.xlsx`}
        />
        {loggedInUserDetails?.role === "ST_ADM_ACCESS" && (
          <button
            className="btn btn-danger ms-2"
            onClick={deleteMultipleRecords}
          >
            <i className="mdi mdi-delete me-1 "></i>
          </button>
        )}
      </div>
      <CheckboxComponent
        setData={setData}
        data={data}
        unfilteredData={unfilteredData}
      />
      <div className="mb-10 mt-2">
        <Space direction="vertical" size={12}>
          <RangePicker
            value={dates || dateValue}
            style={{ height: "36px" }}
            disabledDate={disabledDate}
            onCalendarChange={(val) => setDates(val)}
            onChange={(val) => setDateValue(val)}
            onOpenChange={onOpenChange}
            format="YYYY-MM-DD"
          />
        </Space>{" "}
        &nbsp;&nbsp;
        <Button
          variant="info"
          onClick={() => {
            //  setColLabel("Patients Created");
            searchRecordsBetweenDates("sale_date");
          }}
          disabled={dateInterval.sd ? false : true}
        >
          Search
        </Button>
        &nbsp;&nbsp;
        <Button
          onClick={() => {
            // setResult([]);
            setDurationResult([]);
            setDateValue([]);
            //getDataFromServer();
            // setColLabel("Total Patients");
            setData(unfilteredData);
          }}
        >
          Reset
        </Button>
      </div>
      <div className="patientListSearch">
        <InputGroup className="mb-3">
          <InputGroup.Text id="basic-addon1">Filter</InputGroup.Text>
          <Form.Control
            placeholder="Product / State / Code / Company ..."
            aria-label="Search"
            aria-describedby="basic-addon1"
            name="searchPatients"
            ref={searchRef}
            onChange={(e) => handleSearch(e.target.value)}
          />
          <InputGroup.Text>
            <i
              className="mdi mdi-delete-outline"
              onClick={clearSearch}
              style={{ cursor: "pointer" }}
            ></i>
          </InputGroup.Text>
        </InputGroup>
      </div>
      <DataGrid
        rows={data}
        disableSelectionOnClick
        columns={columns}
        pageSize={10}
        rowsPerPageOptions={[10]}
        displayTitle="Purchases"
        checkboxSelection
        style={{ height: "60vh" }}
        onSelectionModelChange={handleSelectionChange}
      />

      {/* Modal Popup */}
      <Modal show={openModal} centered>
        <Modal.Header closeButton onClick={() => setOpenModal(false)}>
          <Modal.Title>Issue Detail</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <ModalContent currentRecord={currentRecord} />
        </Modal.Body>
      </Modal>

      {/* {JSON.stringify(data)} */}
    </div>
  );
};

const ModalContent = ({ currentRecord }) => {
  return (
    <div className="container-fluid">
      <ModalCardComponent title="Product Details">
        <table class="table">
          <tbody>
            <tr>
              <th scope="row">Date of Issue</th>
              <td>{currentRecord?.sale_date}</td>
            </tr>
            <tr>
              <th scope="row">Issue ID</th>
              <td>{currentRecord?.s_register.sale_id}</td>
            </tr>
            <tr>
              <th scope="row">Product Name</th>
              <td>{currentRecord?.product_name}</td>
            </tr>
            <tr>
              <th scope="row">Product ID</th>
              <td>{currentRecord?.product_code}</td>
            </tr>
            <tr>
              <th scope="row">Product Expiry</th>
              <td>{currentRecord?.product_expiry?.slice(0, 10)}</td>
            </tr>
            <tr>
              <th scope="row">Issued Quantity</th>
              <td>{currentRecord?.quantity}</td>
            </tr>
            <tr>
              <th scope="row">TC Name</th>
              <td>{currentRecord?.tc_name}</td>
            </tr>
            <tr>
              <th scope="row" colSpan={2}>
                Comments
              </th>
            </tr>
            <tr>
              <td colSpan={2}>{currentRecord?.comments}</td>
            </tr>
            {currentRecord?.reciever_comments && (
              <>
                <tr>
                  <th colSpan={2} scope="row">
                    Reciever Comments
                  </th>
                </tr>
                <tr>
                  <td colSpan={2}>{currentRecord?.reciever_comments}</td>
                </tr>
              </>
            )}
          </tbody>
        </table>
      </ModalCardComponent>
    </div>
  );
};

const ModalCardComponent = ({ title, children }) => {
  return (
    <Card style={{ width: "100%" }}>
      <Card.Header>
        <span className="card-title">
          <b>{title}</b>
        </span>
      </Card.Header>
      <Card.Body style={{ wordBreak: "break-word" }}>{children}</Card.Body>
    </Card>
  );
};

const CheckboxComponent = ({ setData, data, unfilteredData }) => {
  const [selectedOption, setSelectedOption] = useState("");

  const handleOptionChange = (e) => {
    setSelectedOption(e.target.value);
  };

  useEffect(() => {
    setData(
      unfilteredData.filter((item) => {
        if (selectedOption === "All") return unfilteredData;
        if (selectedOption === "Received")
          return item?.allotment_recieved_status !== null;
        if (selectedOption === "Awaiting")
          return item?.allotment_recieved_status === null;
      })
    );
  }, [selectedOption]);

  return (
    <div style={{ display: "flex", gap: "10px" }}>
      <label>
        <input
          type="checkbox"
          value="All"
          checked={selectedOption === "All"}
          onChange={handleOptionChange}
        />
        &nbsp;&nbsp;All
      </label>
      <label>
        <input
          type="checkbox"
          value="Received"
          checked={selectedOption === "Received"}
          onChange={handleOptionChange}
        />
        &nbsp;&nbsp;Received
      </label>
      <label>
        <input
          type="checkbox"
          value="Awaiting"
          checked={selectedOption === "Awaiting"}
          onChange={handleOptionChange}
        />
        &nbsp;&nbsp;Awaiting
      </label>
    </div>
  );
};

export default ListSalesChild;
